import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox, faRotateRight } from '@fortawesome/free-solid-svg-icons';

const TicketsEmptyState = ({ filterTab, onReload }) => {
  const getFilterMessage = () => {
    switch (filterTab) {
      case 'pendientes':
        return 'No hay tickets pendientes en este momento.';
      case 'en_progreso':
        return 'No hay tickets en progreso actualmente.';
      case 'cerrados':
        return 'No hay tickets resueltos o cerrados registrados.';
      default:
        return 'No se encontraron tickets de soporte registrados en la base de datos.';
    }
  };

  return (
    <div className="bg-white border rounded-3 p-5 text-center my-3 shadow-none">
      <div
        className="rounded-circle bg-light d-inline-flex align-items-center justify-content-center mb-3"
        style={{ width: '64px', height: '64px' }}
      >
        <FontAwesomeIcon icon={faInbox} className="text-400" style={{ fontSize: '1.8rem' }} />
      </div>
      <h6 className="fw-bold text-800 mb-1">Sin tickets para mostrar</h6>
      <p className="text-500 mb-3" style={{ fontSize: '0.85rem' }}>
        {getFilterMessage()}
      </p>
    </div>
  );
};

export default TicketsEmptyState;
